import { render, staticRenderFns } from "./card-button.svg.vue?vue&type=template&id=34cfe70a&"
import script from "./card-button.svg.vue?vue&type=script&lang=js&"
export * from "./card-button.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports